const state={
    userinfo:null,
}
const getters={}
const actions={}
const mutations={
    setUserInfo(state,v){
        state.userinfo=v.staff?v.staff:v;
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}